import { $ } from '../lib/dom.js';
import { esc } from '../lib/escape.js';
import { read, write } from '../lib/store.js';
import { SPONSOR_TIERS } from '../data/sponsor-tiers.js';

function tierHtml(tier) {
  const perks = tier.perks.map(p => `<li>${esc(p)}</li>`).join('');
  return `
    <article class="tier" data-tier-id="${esc(tier.id)}">
      <div class="name">${esc(tier.name)}</div>
      <div class="tagline">${esc(tier.tagline)}</div>
      <ul class="perks">${perks}</ul>
      <div class="note">${esc(tier.note)}</div>
    </article>
  `;
}

export function renderSponsorsDeck(onSubmitted) {
  const mount = $('#sponsors-deck-mount');
  if (!mount) return;

  const grid = document.createElement('div');
  grid.className = 'tier-grid';
  grid.innerHTML = SPONSOR_TIERS.map(tierHtml).join('');
  mount.appendChild(grid);

  // Register each card with the reveal watcher so .is-in fires on scroll.
  if (typeof onSubmitted === 'function') {
    grid.querySelectorAll('.tier').forEach(el => onSubmitted(el));
  }

  const tierOptions = SPONSOR_TIERS
    .map(t => `<option value="${esc(t.id)}">${esc(t.name)}</option>`)
    .join('');

  const form = document.createElement('form');
  form.className = 'form';
  form.innerHTML = `
    <div>
      <label>// Company</label>
      <input required name="company" placeholder="ACME Inc." />
    </div>
    <div>
      <label>// Your name</label>
      <input required name="name" placeholder="Sam R." />
    </div>
    <div>
      <label>// Email</label>
      <input type="email" required name="email" placeholder="sam@acme.com" />
    </div>
    <div>
      <label>// Tier</label>
      <select required name="tier">
        <option value="">— SELECT —</option>
        ${tierOptions}
        <option value="not-sure">Not sure yet</option>
      </select>
    </div>
    <div>
      <label>// Message</label>
      <textarea name="message" rows="3" placeholder="Tell us what you're imagining."></textarea>
    </div>
    <button type="submit">SUBMIT INQUIRY →</button>
    <div class="helper">We'll reply within 24 hours — or 72 if the baby has a fever.</div>
  `;
  form.addEventListener('submit', e => {
    e.preventDefault();

    const submission = {
      ts:      new Date().toISOString(),
      company: (form.querySelector('[name=company]').value || '').trim(),
      name:    (form.querySelector('[name=name]').value    || '').trim(),
      email:   (form.querySelector('[name=email]').value   || '').trim(),
      tier:    (form.querySelector('[name=tier]').value    || '').trim(),
      message: (form.querySelector('[name=message]').value || '').trim()
    };

    try {
      const current = read('sponsor_inquiries');
      write('sponsor_inquiries', [submission, ...current]);
    } catch {
      // Storage may be unavailable (private mode, quota). Don't block the UX —
      // the confirmation still shows; the submission is only lost locally.
    }

    const companyRaw = (submission.company || 'PROSPECT').toUpperCase();
    const company = esc(companyRaw);
    const sub = document.createElement('div');
    sub.className = 'form submitted';
    sub.innerHTML = `
      <div class="big">Inquiry received.</div>
      <p style="color:#ffd0b3;max-width:32ch;margin:12px 0">
        We'll get back to you between 21:30 and 23:00 (your timezone, hopefully).
      </p>
      <div class="helper">// File: SPONSOR_${company}.TXT</div>
    `;
    form.replaceWith(sub);
    if (typeof onSubmitted === 'function') onSubmitted(sub);
  });
  mount.appendChild(form);
  if (typeof onSubmitted === 'function') onSubmitted(form);
}
